import * as React from 'react';

import classnames from 'classnames';

import {NothingFoundEmptyState} from '../../empty-states/nothing-found-empty-state';
import {StackLegacy} from '../../layout/stack/stack-legacy';
import {SearchBar} from '../../search-bar/search-bar';
import {Body} from '../../typography/body';
import {Header} from '../../typography/header';

import {IntegrationCard} from '../integration-card/integration-card';

import {copy} from './const';

import styles from './integrations-page-content.module.css';

type Props = {
    integrations: Array<any>;
    category: string;
    handleClick: (integrationId: string) => void;
};

export function IntegrationsPageContent(props: Props) {
    const [searchValue, setSearchValue] = React.useState('');

    // filter by category values.
    const filteredByCategory = props.integrations.filter((integration) => {
        return integration.categoryId.includes(props.category) || props.category === 'all';
    });

    // filter by search values.
    const filteredBySearch = filteredByCategory.filter((integration) => {
        // only search on all page
        if (props.category !== 'all') {
            return true;
        }
        if (integration.name.toLowerCase().includes(searchValue.toLowerCase())) {
            return true;
        }
        if (integration.primaryText.toLowerCase().includes(searchValue.toLowerCase())) {
            return true;
        }

        return false;
    });

    const sortedIntegrations = filteredBySearch.sort((a, b) => a.name.localeCompare(b.name));

    const integrationComponentsList = sortedIntegrations.map((integration) => (
        <IntegrationCard
            key={integration.integrationId}
            isSelected={false}
            primaryText={integration.primaryText}
            integrationLogoUrl={integration.integrationLogoUrl}
            logoStyles={integration.logoStyles}
            onClick={() => props.handleClick(integration.integrationId)}
        />
    ));

    return (
        <div
            className={classnames(
                'px-16 pb-32 pt-16 background-white',
                styles['integrations-main-content-wrapper']
            )}
        >
            <StackLegacy spacing={32}>
                <div>
                    {/* @ts-expect-error */}
                    <Header as='h1'>{copy[props.category].header}</Header>
                    <div className={styles['description-container']}>
                        {/* @ts-expect-error */}
                        <Body size='large'>{copy[props.category].body}</Body>
                    </div>
                </div>
                <StackLegacy spacing={16}>
                    {props.category === 'all' && (
                        <SearchBar
                            value={searchValue}
                            onChange={(event) => {
                                setSearchValue(event);
                            }}
                            hasBorder={true}
                        />
                    )}
                    {integrationComponentsList.length === 0 ? (
                        <div className='full-width flex justify-center'>
                            <NothingFoundEmptyState
                                title='No integrations found'
                                subtitle='Try a different search'
                            />
                        </div>
                    ) : (
                        <div className={styles['integrations-grid-container']}>
                            {integrationComponentsList}
                        </div>
                    )}
                </StackLegacy>
            </StackLegacy>
        </div>
    );
}
